<script setup>
import { defineProps } from 'vue';
import { getImageUrl } from "@/utils/getImageUrl";
import { computed } from "vue";

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
  product: {
    type: Object,
    required: true,
  },
  // product: Object,
  showTitle: {
    type: Boolean,
    default: true
  }
});

const getAttributeValue = computed(() => {
  const productAttribute = props.product.attributes.find((el) => el.title  === props.attribute.title)
  if (productAttribute?.value) {
    return productAttribute?.value
  }
  return props.product[props.attribute.name]
})

</script>

<template>
  <dl v-if="attribute && getAttributeValue !== null"
      class="attribute has-value"
      itemprop="additionalProperty"
      itemscope
      itemtype="http://schema.org/PropertyValue">

    <template v-if="attribute.title && showTitle && attribute.format !== 'youtube' && attribute.format !== 'link'">
      <dt class="text-ellipsis" :class="'type-' + attribute.type" itemprop="name">
        <img v-if="attribute.icon?.length"
             :src="getImageUrl(attribute.icon[0])"
             class="product-attribute-icon"
             alt="" />
        {{ attribute.title }}
      </dt>
    </template>

    <meta v-else itemprop="name" :content="attribute.title" />

    <dd v-if="attribute.format === 'youtube'" class="type-video">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe class="youtube embed-responsive-item"
                :src="'//www.youtube-nocookie.com/embed/' + getAttributeValue + '?rel=0'"
                frameborder="0"
                allowfullscreen>
        </iframe>
      </div>
    </dd>

    <dd v-else :class="['type-' + attribute.type, { 'rich-html': attribute.format === 'rich text' }]" itemprop="value">
      <template v-if="attribute.type === 'boolean'">
        {{ getAttributeValue ? '\u2713' : '\u2013' }}
      </template>

      <template v-else-if="attribute.type === 'list'">
        <ul>
          <li v-for="(item, index) in getAttributeValue.split('|')" :key="index">{{ item }}</li>
        </ul>
      </template>

      <template v-else>
        <span v-if="attribute.format === 'rich text'" class="attribute-rich-text" v-html="getAttributeValue"></span>
        <template v-else>
          <a v-if="attribute.format === 'link'" :href="getAttributeValue" target="_blank">
            <span v-html="attribute.title || getAttributeValue"></span>
          </a>
          <span v-else class="tooltipped tooltipped-n" :aria-label="getAttributeValue">
            <span class="text-ellipsis">{{getAttributeValue}}</span>
          </span>
        </template>
        <span v-if="attribute.suffix"> &nbsp; {{ attribute.suffix }}</span>
      </template>
    </dd>
  </dl>
</template>
